// extracted by css-extract-rspack-plugin
var _1 = "markdown-UQngKy";
export { _1 as "markdown" }
